/*
 * Custom jQuery plugins.
 */
$.fn.clickableRows = function() {
	return this.each( function() {
		var $a, $target, isInput, isIgnore;

		$( this )
			.find( "tbody tr" )
			.on( "click", function( e ) {
				$target = $( e.target );
				isInput = $target.is( "input" );
				isIgnore = $target.is( ".ignore" );

				if ( isInput || isIgnore ) {
					if ( isIgnore ) {
						$target.parent().find( "input" ).trigger( "click" );
					}

					return;
				}

				$a = $( this ).find( "a" );

				if ( $a.length ) {
					window.location = $a.attr( "href" );
				}

				return false;
			} );
	} );
};

$.fn.autosubmit = function() {
	return this.each( function() {
		var $form = $( this );

		if ( !$form.is( "form" ) ) {
			return;
		}

		$form.find( "select" ).on( "change", function() {
			$form.trigger( "submit" );
		} );
	} );
};

/* global window */
( function( window, $, undefined ) {
	"use strict";
	var document = window.document,
		ko = window.ko,
		md5 = window.md5,
		LANG = $( "html" ).attr( "lang" ),

	SKELET = {
		common: {

			// Application-wide code.
			init: function() {
				if ( $( "#nav-folders" ).length ) {
					ko.applyBindings( new SKELET.UTIL.FoldersViewModel() );
				}

				// Responsive breakpoints' callbacks.
				$( window ).setBreakpoints( {
					breakpoints: [ 1, 768, 992, 1200 ]
				} );
				$( window )
					.on( "enterBreakpoint1", function() {
						SKELET.UTIL.responsiveNav.attache();
					} )
					.on( "exitBreakpoint1", function() {
						SKELET.UTIL.responsiveNav.detache();
					} );

				$( "[data-toggle='tooltip']" ).tooltip();

				// Form hints.
				$( ".help-hint" ).each( function() {
					var $this = $( this ),
						$field = $this.closest( ".form-group" ).find( ".form-control" ),
						title = $this.data( "title" ) || "",
						content = $this.html();

					$field.popover( {
						html: true,
						trigger: "focus",
						title: title,
						content: content
					} );
				} );

				// Clickable table rows.
				$( ".table-clickable" ).clickableRows();

				// Handle sliding responsive navigation.
				SKELET.UTIL.responsiveNav.init();

				// Form hints.
				$( ".help-hint" ).each( function() {
					var $this = $( this ),
						$field = $this.closest( ".form-group" ).find( ".form-control" ),
						title = $this.data( "title" ) || "",
						content = $this.html(),
						popoverOptions = {
							html: true,
							trigger: "focus",
							title: title,
							content: content
						};

					$field.popover( popoverOptions );
				} );
			}
		},

		drafts: {
			edit: function() {

				// Enter key handling in email edit.
				var $form = $( "#form_drafts_edit" ),
					$inputs = $form.find( "input" );

				$inputs.on( "keydown", null, "return", function( e ) {
					e.preventDefault();
				} );

				// TODO: Ctrl+Enter sends email.
				/*
				$textarea.on( "keydown", null, "ctrl+return", function( e ) {
					$form.submit();
				});
				*/

				// Email autocompletion.
				SKELET.UTIL.utils.emailSuggest( "#id_to" );
				SKELET.UTIL.utils.emailSuggest( "#id_cc" );
				SKELET.UTIL.utils.emailSuggest( "#id_bcc" );
			}
		},

		filters: {
			index: function() {

				// Remove table row after filter has had been deleted.
				$( ".content-main table .btn-danger" ).on( "ajax:success", function() {
					$( this ).closest( "tr" ).fadeOut( function() {
						$( this ).remove();
					} );
				} );
			}
		},

		logins: {

			create_new: function() {

				/*
				 * Salted login implementation.
				 */
				var $form = $( "#form_logins_create_new" ),
					$login = $( "#id_login" ),
					$password = $( "#id_password" ),
					apiActions = $form.data( "api-actions" ),
					login, password, saltsJqxhr, loginJqxhr, hpassword, $msg;

				$login.focus();

				$form.submit( function( e ) {
					e.preventDefault();

					if ( $msg ) {
						$msg.alert( "close" );
					}

					login = $login.val();
					password = $password.val();

					// Get salts.
					saltsJqxhr = $.getJSON( apiActions.salts, {
						login: login,
						format: "json"
					} );

					saltsJqxhr.done( function( json ) {
						hpassword = md5( json.time_salt +
							md5( md5( password ) + json.password_salt ) );

						// Login.
						loginJqxhr = $.post( apiActions.login, {
							login: login,
							hpassword: hpassword,
							time_salt: json.time_salt,
							format: "json"
						}, "json" );

						loginJqxhr.done( function() {
							window.location.replace( apiActions.redirect );
						} );

						loginJqxhr.fail( function( jqxhr ) {
							switch ( jqxhr.status ) {
								case 403:
									$password.select().focus();
									break;
								case 404:
									$login.select().focus();
									break;
							}

							$msg = $( "<p class='alert alert-danger fade in'>" +
								$.parseJSON( jqxhr.responseText ) + "</p>" ).insertBefore( $form );
							$msg.alert();
						} );
					} );
				} );
			}
		},

		users: {

			// Controller-wide code.
			init: function() {
			},

			// Action-specific code
			create_new: function() {

				// Na http://listonos14.localhost/cs/users/create_new/ chceme:
				//  * heslo i kontrolu hesla zahashovat a posolit pouze prihlasovaci soli
				//  * a formular s takto upravenyma heslama odeslat
				var $form = $( "#form_users_create_new" ),
				$password = $( "#id_password" ),
				$passwordRepeat = $( "#id_password_repeat" ),
				$login = $( "#id_login" ),
				apiRoot = $( "meta[name=api-root]" ).attr( "content" ),
				saltsJqxhr;

				$form.submit( function( e ) {

					e.preventDefault();

					// Get salts.
					saltsJqxhr = $.getJSON( apiRoot + "login_salts/detail", {
						login: $login.val(),
						format: "json"
					} );

					saltsJqxhr.done( function( json ) {
						$password.val( md5( md5( $password.val() ) + json.password_salt ) );
						$passwordRepeat.val( md5( md5( $passwordRepeat.val() ) +
							json.password_salt ) );

						$form.off( "submit" ); // Prevents recursion
						$form.submit();
					} );
				} );
			},

			edit_password: function() {

				// Na http://listonos14.localhost/cs/users/edit_password/ chceme:
				//	* aktualni heslo zahashovat a posolit prihlasovaci i casovou soli
				//  * nove heslo i kontrolu noveho hesla
				//		zahashovat a posolit pouze prihlasovaci soli
				//  * do formulare pridat casovou sul, kterou bylo soleno aktualni heslo
				//  * a formular odeslat
				var $form = $( "#form_users_edit_password" ),
				$currentPassword = $( "#id_current_password" ),
				$password = $( "#id_password" ),
				$passwordRepeat = $( "#id_password_repeat" ),
				login = $( "meta[name=login]" ).attr( "content" ),
				apiRoot = $( "meta[name=api-root]" ).attr( "content" ),
				saltsJqxhr;

				$form.submit( function( e ) {
					e.preventDefault();

					// Get salts.
					saltsJqxhr = $.getJSON( apiRoot + "login_salts/detail", {
						login: login,
						format: "json"
					} );

					saltsJqxhr.done( function( json ) {

						$currentPassword.val( md5( json.time_salt +
							md5( md5( $currentPassword.val() ) + json.password_salt ) ) );
						$password.val( md5( md5( $password.val() ) + json.password_salt ) );
						$passwordRepeat.val( md5( md5( $passwordRepeat.val() ) +
							json.password_salt ) );

						// Potrebujeme odeslat i casovou sul, kterou bylo osoleno aktualni heslo
						$( "<input type='hidden' name='time_salt' value='" +
							json.time_salt + "'>" ).appendTo( $form );

						$form.off( "submit" ); // Prevents recursion
						$form.submit();
					} );
				} );
			}
		},

		emails: {
			index: function() {

				// Hromadne akce.
				SKELET.UTIL.bulkOperations();

				$( "#form_limit" ).autosubmit();
			},
			detail: function() {

				// Contact popover.
				SKELET.UTIL.handleContactPopover();

				$( "#form_emails_edit" ).autosubmit().on( "ajax:success", function() {

					// Replace navigation.
					//$( ".nav-folders" ).html( data.menu_src );
					// Change dropdown text.
					$( ".btn-toolbar .dropdown-toggle em" ).
						text( $( "#id_folder_id :selected" ).text() );
				} );

				// Handle dropdown folder selection.
				var $dropdown = $( SKELET.UTIL.utils.selectToDropdown(
					$( "#id_folder_id" ) ) ).appendTo( ".btn-toolbar .btn-group.with-folders"
				);

				$dropdown.find( ".dropdown-toggle" ).
					prepend( "<span class='glyphicon glyphicon-folder-close'></span> " );
			}
		}

	};

	/*
	 * Garber-Irish DOM-based routing.
	 * See: http://goo.gl/z9dmd
	 */
	SKELET.UTIL = {
		exec: function( controller, action ) {
			var ns = SKELET,
				c = controller,
				a = action;

			if ( a === undefined ) {
				a = "init";
			}

			if ( c !== "" && ns[ c ] && typeof ns[ c ][ a ] === "function" ) {
				ns[ c ][ a ]();
			}
		},

		init: function() {
			var body = document.body,
			controller = body.getAttribute( "data-controller" ),
			action = body.getAttribute( "data-action" );

			SKELET.UTIL.exec( "common" );
			SKELET.UTIL.exec( controller );
			SKELET.UTIL.exec( controller, action );
		},

		Folder: function( data ) {
			this.id = data.folder.id;
			this.name = data.folder.name;
			this.type = data.folder.type;
			this.glyph = data.folder.glyph;
			this.count = ko.observable( data.count );
			this.totalCount = ko.observable( data.total_count );
			this.href = "/" + LANG + "/emails/?folder_id=" + this.id;
			this.warning = data.folder.warning;
		},

		FoldersViewModel: function() {
			var self = this,
				route = "/api/" + LANG + "/unread_emails_counts/",
				premappedFolders = $.map( $( "[data-folders]" ).data( "folders" ).folders,
					function( item ) {
					return new SKELET.UTIL.Folder( item );
				} ),
				reqTime = "",
				timeoutId;

			self.folders = ko.observableArray( premappedFolders );

			self.firstRun = true;
			self.hasNewMessages = ko.observable();

			self.update = function( firstRun ) {
				window.clearTimeout( timeoutId );

				$.getJSON( route, { format: "json", time: reqTime }, function( json ) {
					var mappedFolders = $.map( json.folders, function( item ) {
						if ( !firstRun && item.count > 0 ) {
							self.hasNewMessages( true );
						}

						return new SKELET.UTIL.Folder( item );
					} );

					self.folders( mappedFolders );

					// Store initial request time.
					if ( firstRun ) {
						reqTime = json.current_time;
						self.firstRun = false;
					}

					timeoutId = window.setTimeout( self.update, 60000 );
				} );
			};

			self.update( self.firstRun );
		},

		bulkOperations: function() {
			var $form = $( "#form_emails_bulk_operation" ),
				$th = $form.find( "thead th:first" ),
				$cb = $( "<input type='checkbox'>" ).appendTo( $th ),
				$cbs = $form.find( ".ignore input" ),
				$dropdown = $( SKELET.UTIL.utils.
					selectToDropdown( $( "#id_operation" ) ) ).prependTo( $form ),
				$select = $form.find( "select" );

			// Dropdown's text.
			$dropdown.find( "button" ).prepend( "Vybrat hromadnou akci" );

			// Check all/unchceck all.
			$cb.on( "change", function() {
				if ( $cb.is( ":checked" ) ) {
					$cbs.prop( "checked", true );
				} else {
					$cbs.prop( "checked", false );
				}
			} );

			// Dropdown's conditional hiding.
			$cbs.add( $cb ).on( "change", function() {
				if ( $cbs.add( $cb ).filter( ":checked" ).length ) {
					$dropdown.fadeIn();
				} else {
					$dropdown.hide();
				}
			} ).trigger( "change" );

			$select.on( "change", function() {
				var $select = $( this );
				if ( $select.val() === "destroy" ) {
					if ( !confirm( "Opravdu?" ) ) {
						return false;
					}
				}
				$form.trigger( "submit" );
			} );
		},

		handleContactPopover: function() {
			var $contact = $( "#contact-from" ).popover( {
				html: true,
				trigger: "manual",
				title: function() {
					return $( "#contact-from" ).text();
				},
				content: function() {
					return $( "#contact-popover" ).html();
				}
			} ),
				isOver = false,
				to;

			$( document )
				.on( "mouseenter", ".popover", function() {
					isOver = true;
				} )
				.on( "mouseleave", ".popover", function() {
					isOver = false;
					$contact.popover( "hide" );
				} );

			$contact
				.on( "mouseenter", function() {
					window.clearTimeout( to );
					$contact.popover( "show" );
				} )
				.on( "mouseleave", function() {
					to = window.setTimeout( function() {
						if ( !isOver ) {
							$contact.popover( "hide" );
						}
					}, 200 );
				} );
		},

		responsiveNav: {
			init: function() {
				this.$nav_folders = $( ".nav-folders" );
				this.$brand = $( ".header-main .navbar-brand" );

				var wh = $( window ).height(),
					nh = this.$nav_folders.height(),
					bh = 50;

				if (  nh > ( wh - bh ) ) {
					this.$nav_folders.height( wh - bh ).addClass( "scrollable" );
				}
			},
			attache: function() {
				var that = this;

				if ( this.checkElems ) {
					this.$brand.on( "click", function( e ) {
						if ( !that.$nav_folders.is( ":visible" ) ) {
							SKELET.UTIL.utils.overlay.show( that.$nav_folders );
							that.$nav_folders.fadeIn();
						} else {
							SKELET.UTIL.utils.overlay.hide();
							that.$nav_folders.fadeOut();
						}

						e.preventDefault();
					} );
				}
			},
			detache: function() {
				if ( this.checkElems ) {
					this.$brand.off( "click" );
				}
			},
			checkElems: function() {
				return ( !this.$nav_folders.length || !this.$brand.length );
			}
		},

		utils: {
			emailSuggest: function( selector ) {
				var $input = $( selector ),
					url = "/api/" + $( "html" ).attr( "lang" ) +
						"/email_addresses_suggestions/?format=json&q=",
					cache = {},
					term, terms;

				function split( val ) {
					return val.split( /,\s*/ );
				}
				function extractLast( t ) {
					return split( t ).pop();
				}

				if ( !$input.length ) {
					return;
				}

				$input.autocomplete( {
					minLength: 2,
					source: function( request, response ) {
						term = extractLast( request.term );

						if ( term in cache ) {
							response( cache[ term ] );
						} else {
							$.getJSON( url + term, function( data ) {
								cache[ term ] = data;
								response( data );
							} );
						}
					},
					search: function() {
						term = extractLast( this.value );

						if ( term.length < 2 ) {
							return false;
						}
					},
					focus: function() {
						return false;
					},
					select: function( event, ui ) {
						terms = split( this.value );
						terms.pop();
						terms.push( ui.item.value );
						terms.push( "" );
						this.value = terms.join( ", " );
						return false;
					}
				} );
			},

			selectToDropdown: function( $select ) {
				var $dropdown, $options, $items, items = "";

				if ( !$select.length || !$select.is( "select" ) ) {
					return;
				}
				$dropdown = $( "<div class='btn-group'>" +
					"<button type='button' class='btn btn-default dropdown-toggle'" +
					" data-toggle='dropdown'>" +
					"<em>" + $select.find( ":selected" ).text() +
					"</em> <span class='caret'></span></button>" +
					"<ul class='dropdown-menu' role='menu'></ul></div>" );
				$options = $select.find( "option" );

				$options.each( function() {
					var $option = $( this ),
						value = $option.attr( "value" ),
						text = $option.text();

					items += "<li><a href='#' data-value='" + value + "'>" + text + "</a></li>";
				} );

				$( items ).appendTo( $dropdown.find( "ul" ) );

				$items = $dropdown.find( ".dropdown-menu a" );

				$items.on( "click", function( ev ) {
					var $link = $( this ),
						value = $link.data( "value" );

					$select.val( value ).trigger( "change" );

					ev.preventDefault();
				} );

				return $dropdown;
			},

			overlay: {
				init: function() {
					var that = this,
						$elem = this.elem = $( "<div class='ui-overlay'></div>" ).
							appendTo( "body" );

					$elem
						.on( "click", function() {
							that.target.fadeOut();
							that.hide();
						} )
						.width( $( document ).width() )
						.height( $( document ).height() );

					return this.elem;
				},
				show: function( target ) {
					this.target = target;

					if ( this.exists() ) {
						this.elem.fadeIn();
					} else {
						this.init().fadeIn();
					}
				},
				hide: function() {
					this.elem.fadeOut();
				},
				exists: function() {
					return this.elem && this.elem.length;
				}
			}
		}
	};

	// Expose SKELET to the global object.
	window.SKELET = SKELET;

	// Initialize application.
	SKELET.UTIL.init();

} )( window, window.jQuery );
